import { isNotEmpty } from './common';

type ContactWithPrimaryFields = {
  primaryFields: {
    firstName?: { data?: string | null } | null;
    lastName?: { data?: string | null } | null;
    nameFull?: { data?: string | null } | null;
    name?: { data?: string | null } | null;
  };
};

type ContactWithFlatFields = {
  first_name: string | null;
  last_name: string | null;
};

/** For nested primaryFields contact shapes - returns array of name parts */
export const contactNames = (contact: ContactWithPrimaryFields) => {
  const firstName = contact.primaryFields.firstName?.data;
  const lastName = contact.primaryFields.lastName?.data;
  const nameFull = contact.primaryFields.nameFull?.data;
  const name = contact.primaryFields.name?.data;

  return (firstName != null && lastName != null ? [firstName, lastName].filter(isNotEmpty) : [nameFull ?? name]).filter(
    isNotEmpty,
  );
};

/** For nested primaryFields contact shapes - returns joined name string */
export const contactName = (contact: ContactWithPrimaryFields) => contactNames(contact).join(' ');

/** For flat contact shapes with first_name/last_name fields */
export const contactNameFlat = (contact: ContactWithFlatFields) =>
  [contact.first_name, contact.last_name].filter(isNotEmpty).join(' ');

/**
 * Compact "time in stage" label for the pipeline board: days under a week, then
 * weeks under a month, then months under a year, then years (e.g. `3d`, `2w`,
 * `1mo`, `1y`). Negative spans (clock skew / future timestamps) clamp to `0d`,
 * and an unparseable date returns `''` so the caller renders nothing. Pass `now`
 * for deterministic tests.
 */
export const formatStageDuration = (enteredAt: Date | string, now: Date = new Date()): string => {
  const start = enteredAt instanceof Date ? enteredAt : new Date(enteredAt);
  const startMs = start.getTime();
  if (Number.isNaN(startMs)) return '';
  const days = Math.floor((now.getTime() - startMs) / 86_400_000);
  if (days < 1) return '0d';
  if (days < 7) return `${days}d`;
  if (days < 30) return `${Math.floor(days / 7)}w`;
  if (days < 365) return `${Math.floor(days / 30)}mo`;
  return `${Math.floor(days / 365)}y`;
};
